/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import HomePageMeta from "@/src/containers/Pages/Generic/HomePage/HomePageMeta";
import Layout from "@/src/containers/Layouts/Layout";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import { logout } from "@/src/store/login/actions";
import StatisticsSection from "@/src/components/Sections/Generic/StatisticSection/StatisticsSection";
import AreasOfLawOverview from "@/src/components/Sections/Generic/AreasOfLawOverview/AreasOfLawOverview";
import OurService from "@/src/components/OurService/OurService";
import ServiceworldHero from "@/src/components/Sections/Generic/ServiceworldHero/ServiceworldHero";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import ValueProposition from "@/src/components/Sections/Generic/ValueProposition/ValueProposition";

const HomePage = () => {
  useEffect(() => {
    logout();
  }, []);

  return (
    <Layout backgroundType={"homepage"}>
      <HomePageMeta />
      <ServiceworldHero />
      <ValueProposition />
      <AreasOfLawOverview />
      <StatisticsSection />
      <OurService />
      <PartnersSection />
      <CustomerFeedback />
    </Layout>
  );
};

export default HomePage;
